import { Tab } from "bootstrap";
import TrForm from "./modules/TrForm";
import MainForm from "./modules/MainForm";
import InfoCardsCarousel from "./modules/InfoCardsCarousel";
import CtaForm from "./modules/CtaForm";
import InfoExpander from "./modules/InfoExpander";
import Accordion from "./modules/Accordion";
import BlockVideo from "./modules/BlockVideo";
import AnimateCards from "./modules/AnimateCards";
import ResultsHeader from "./modules/ResultsHeader";
import ResultsNav from "./modules/ResultsNav";
import BlockHero from "./modules/BlockHero";
import BlockStatus from "./modules/BlockStatus";
import BlockBoost from "./modules/BlockBoost";
import BlockCommute from "./modules/BlockCommute";
import BlockSubject from "./modules/BlockSubject";
import BlockCampus from "./modules/BlockCampus";
import BlockNextSteps from "./modules/BlockNextSteps";
import BlockCTA from "./modules/BlockCTA";
import BlockCompetition from "./modules/BlockCompetition";
import ResultsFooter from "./modules/ResultsFooter";
import CompetitionForm from "./modules/CompetitionForm";
import initBlockIconAnimations from "./modules/BlockIconAnimations";

// Results page fade in
const resultsPage = document.querySelector('.results-page');
if(resultsPage) {
  setTimeout(() => {
	resultsPage.classList.add('loaded');
  }, 1000);

  const SCROLLED_ON_Y = 200;
  const SCROLLED_OFF_Y = 5;

  const toggleScrolledClass = () => {
    const isScrolled = document.body.classList.contains('scrolled');
    const currentY = window.scrollY;

    if (!isScrolled && currentY >= SCROLLED_ON_Y) {
      document.body.classList.add('scrolled');
    } else if (isScrolled && currentY <= SCROLLED_OFF_Y) {
      document.body.classList.remove('scrolled');
    }
  };

  toggleScrolledClass();
  window.addEventListener('scroll', toggleScrolledClass, { passive: true });
}

// Shared block title icon lottie animations
initBlockIconAnimations();

// Results header animation
const resultsHeader = document.querySelector('.block-results-header');
if(resultsHeader) {
	new ResultsHeader(resultsHeader);
}

// Results nav carousel (mobile)
const resultsNav = document.querySelector('.block-results-nav');
if(resultsNav) {
	new ResultsNav(resultsNav);
}

// Results hero animation
const blockHero = document.querySelector('.block-hero');
if(blockHero) {
  new BlockHero(blockHero);
}

// Status block animation
const blockStatus = document.querySelector('.block-status');
if(blockStatus) {
  new BlockStatus(blockStatus);
}

// Boost block animation
const blockBoost = document.querySelector('.block-boost-offer');
if(blockBoost) {
  new BlockBoost(blockBoost);
  new AnimateCards(blockBoost);
}

// Commute block animation
const blockCommute = document.querySelector('.block-commute');
if(blockCommute) {
  new BlockCommute(blockCommute);
  new AnimateCards(blockCommute);
}

// Subject block animation
const blockSubject = document.querySelector('.block-subject');
if(blockSubject) {
  new BlockSubject(blockSubject);
}

// Campus block animation
const blockCampus = document.querySelector('.block-campus');
if(blockCampus) {
  new BlockCampus(blockCampus);
  new AnimateCards(blockCampus);
}

// Next steps block animation
const blockNextSteps = document.querySelector('.block-next-steps');
if(blockNextSteps) {
  new BlockNextSteps(blockNextSteps);
}

// CTA block animation
const blockCTA = document.querySelector('.block-cta');
if(blockCTA) {
  new BlockCTA(blockCTA);
}

// Competition block beach ball animation
const blockCompetition = document.querySelector('.block-competition');
if(blockCompetition) {
  new BlockCompetition(blockCompetition);
}

// Results footer animation
const resultsFooter = document.querySelector('.block-results-footer');
if(resultsFooter) {
  new ResultsFooter(resultsFooter);
}

// Block video play (works anywhere .block-video markup is used)
const blockVideos = document.querySelectorAll('.block-video');
blockVideos.forEach(block => new BlockVideo(block));

// Info expander cards
new InfoExpander();

// Main form behaviour
const mainForm = document.querySelector('#main-form');
if(mainForm) {
	new MainForm(mainForm);
}

// Capture form submissions
const trForms = document.querySelectorAll('.tr-form');
if(trForms) {
	trForms.forEach(form => {
		new TrForm(form);
	});
}

// Competition / prize draw form (Gecko public API)
const competitionForm = document.querySelector('#competition-form');
if(competitionForm) {
	new CompetitionForm(competitionForm);
}

// Info cards carousels
const infoCardsCarousel = document.querySelectorAll(".info-cards-carousel");
if (infoCardsCarousel) {
	infoCardsCarousel.forEach(block => new InfoCardsCarousel(block));
}

// CTA block add-email
const ctaBlock = document.querySelector(".block-cta");
if (ctaBlock) {
	new CtaForm(ctaBlock);
}

// Accordions
const details = document.querySelectorAll("details");
if(details) {
  details.forEach((i) => {
    new Accordion(i);
  });
}

// Commute options: at 992px+ show all details expanded (no accordion)
const commuteOptions = document.querySelector(".commute-options.accordion");
if (commuteOptions) {
  const commuteDetails = commuteOptions.querySelectorAll("details");
  const setCommuteExpanded = () => {
    const expanded = window.matchMedia("(min-width: 992px)").matches;
    commuteDetails.forEach((d) => {
      d.open = expanded;
      const summary = d.querySelector("summary");
      if (summary) {
        summary.setAttribute("aria-expanded", expanded);
        summary.classList.toggle("collapsed", !expanded);
      }
    });
  };
  setCommuteExpanded();
  window.addEventListener("resize", setCommuteExpanded);
}
